module.exports = __webpack_public_path__ + "img/解决方案_定制_绿.4313cf10.svg";